var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.697 6.886c.784-.785 2.152-.785 2.936 0l.49.489.978-.979-.49-.49a3.436 3.436 0 00-2.446-1.013c-.925 0-1.794.36-2.447 1.014L2.25 7.375a3.466 3.466 0 001.122 5.644c.42.174.87.263 1.324.262a3.45 3.45 0 002.448-1.012l.49-.49-.98-.978-.489.49a2.081 2.081 0 01-2.937 0 2.08 2.08 0 010-2.937l1.469-1.468z",
    fill: "#353844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.144 2.48l-.49.49.98.979.489-.49a2.081 2.081 0 012.936 0 2.08 2.08 0 010 2.937L9.591 7.864c-.785.784-2.152.784-2.936 0l-.49-.49-.978.98.489.489a3.437 3.437 0 002.447 1.014c.924 0 1.794-.36 2.446-1.014l1.47-1.468a3.466 3.466 0 000-4.894 3.465 3.465 0 00-4.895 0z",
    fill: "#353844"
  })));
}
export default __webpack_public_path__ + "media/icons/copy-link-6c7a3fce.svg";
export { SvgCopyLink as ReactComponent };